import { callApi } from 'services/config';

export const getOneSchemaJWT = async (companyId: string) => {
  const path = `/oneschema/jwt`;
  return await callApi(path, 'get', { companyId });
};
